
const quickModal = document.querySelector('[js-klaviyo-popup]');
const initializeKlaviyoTrigger = () => {
  const klaviyoTriggerBtns = document.querySelectorAll("[js-klaviyo-trigger]");
  klaviyoTriggerBtns.forEach((btn) => {
  btn.addEventListener("click", (event)=> {
  
    const productId = btn.getAttribute('js-klaviyo-trigger');
    const productTitle = btn.getAttribute('data-product-title');
    const variantJSONSelector = document.querySelector(`[data-product-variants="${productId}"]`);
    const variantsJSON = JSON.parse(variantJSONSelector?variantJSONSelector.innerHTML:'[]');
    const unavailableVariantsJSON = variantsJSON.filter((variant) => variant.available == false); 
    console.log('variantJSONSelector', unavailableVariantsJSON);
    if(quickModal) {
        quickModal.classList.add('active');
        document.body?.classList.add('overflow-hidden');
        quickModal.querySelector('[js-product-title]').innerText = productTitle;
        let optionsHTML = '';
        unavailableVariantsJSON.map((variant) =>{
          optionsHTML+=`<option value="${variant.id}">${variant.title}</option>`;
        }); 
        quickModal.querySelector('[js-variant-select]').innerHTML = optionsHTML;
        if(unavailableVariantsJSON[0].title == 'Default Title') {
            quickModal.querySelector('[js-variant-select]').classList.add('hidden');
        }
      
        quickModal.querySelector('#completed_message').style.display = 'none';
        quickModal.querySelector('#error_message').style.display = 'none';
        quickModal.querySelector('[js-submit-btn]').style.display = 'block';
    }
  });
});
}
const bisTriggerForm = document.querySelector('[js-back-in-stock-form]');
if(bisTriggerForm) {
    bisTriggerForm.addEventListener("submit", (event) => {
      console.log('submit');
      event.preventDefault();
        
         const selectedVariantID = bisTriggerForm.querySelector('[js-variant-select]').value;
        const email = bisTriggerForm.querySelector('[js-email]').value;
     
         const payload = {
"data": {
"type": "back-in-stock-subscription",
"attributes": {
"profile": {
  "data": {
      "type": "profile",
      "attributes": {
          "email": `${email}`,
      }
  }
},
"channels": ["EMAIL"],
},
"relationships": {
"variant": {
  "data": {
    "type": "catalog-variant",
    "id": `$shopify:::$default:::${selectedVariantID}`
  }
}
}
}
}

        var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2024-06-15"
            },
            body: JSON.stringify(payload),
        };
        
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=MC76rC",requestOptions)
        .then(response => response)
         .then(data => {
           console.log('data', data);
            if(data.statusText == '' && data.status == 202) {
                bisTriggerForm.querySelector('#completed_message').style.display = 'block';
                bisTriggerForm.querySelector('#error_message').style.display = 'none';
                bisTriggerForm.querySelector('[js-submit-btn]').style.display = 'none';
            }
            else {
              console.log('error');
               bisTriggerForm.querySelector('#error_message').style.display = 'block';
               bisTriggerForm.querySelector('#completed_message').style.display = 'none';
            }
          })
          .catch(error => {
              console.log('error', error)
        });
    });
}
  
  
const quickModalCloseBtns = document.querySelectorAll("[js-modal-close]");
quickModalCloseBtns.forEach((quickModalCloseBtn) => {
  quickModalCloseBtn?.addEventListener("click", (event)=> {
          quickModal?.classList.remove('active');
          document.body?.classList.remove('overflow-hidden');
  });
});

quickModal?.addEventListener('click', ({ target }) => {
  if(quickModal.classList.contains('active')) {
    const quickModalInner = target.closest('#container');
    if(quickModalInner == null && !target.classList.contains('container-inner')) {
        quickModal?.classList.remove('active');
      document.body?.classList.remove('overflow-hidden');
    }
}
});

initializeKlaviyoTrigger();

 
